import "./src/styles/global.css"

// Scroll ke atas saat pindah halaman (kecuali tombol back/forward)
export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  if (prevRouterProps && routerProps.location.pathname === prevRouterProps.location.pathname) return false
  return true
}

// Track pageview ke Google Analytics saat navigasi client-side
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search + location.hash,
    })
  }
}
